// extracted by mini-css-extract-plugin
module.exports =  {"tc-badge-format-value":"BadgeOverlay-module__tc-badge-format-value___gOTHO"};